(()=>{
  const pad=n=>String(n).padStart(2,'0');
  const esc=s=>String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money=c=>(window.cxCurPrefix=window.cxCurPrefix||(((document.querySelector('.cx-bdl__pr')||{}).textContent||'').trim().match(/^[^\d]*/)[0]||((window.Shopify&&Shopify.currency&&Shopify.currency.active||'USD')==='USD'?'$':Shopify.currency.active+' ')))+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');

  /* countdown */
  function cd(){
    const now=Date.now();
    document.querySelectorAll('[data-cx-countdown]').forEach(el=>{
      const end=Date.parse(el.dataset.cxCountdown);
      if(isNaN(end))return;
      let d=Math.max(0,Math.floor((end-now)/1000));
      if(d<=0){document.documentElement.classList.add('cx-expired');return;}
      const days=Math.floor(d/86400);d%=86400;const h=Math.floor(d/3600);d%=3600;const m=Math.floor(d/60);const s=d%60;
      const set=(k,v)=>{const n=el.querySelector('[data-u="'+k+'"]');if(n&&n.textContent!==v)n.textContent=v;};
      set('d',String(days));set('h',pad(h));set('m',pad(m));set('s',pad(s));
    });
  }
  /* delivery estimate */
  function addBiz(n){const d=new Date();let k=n;while(k>0){d.setDate(d.getDate()+1);const w=d.getDay();if(w!==0&&w!==6)k--;}return d;}
  const fmt=d=>d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
  function eta(){
    document.querySelectorAll('[data-cx-eta]:not([data-done])').forEach(el=>{
      const r=el.dataset.cxEta.split(',').map(Number);
      el.textContent=fmt(addBiz(r[0]))+' – '+fmt(addBiz(r[1]));
      el.dataset.done='1';
    });
  }

  /* add items to cart, then apply bundle code */
  async function addItems(items,code,btn){
    btn.disabled=true;const t=btn.textContent;btn.textContent='Adding to cart...';
    try{
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      if(!r.ok)throw new Error('add');
      location.href='/discount/'+code+'?redirect=/cart';
    }catch(e){btn.disabled=false;btn.textContent='Please choose available options and try again';setTimeout(()=>{btn.textContent=t;},3000);}
  }

  /* product page bundle */
  function bdl(w){
    let tot=0,n=0;
    w.querySelectorAll('[data-item]').forEach(li=>{
      const cb=li.querySelector('input[data-on]');const on=cb?cb.checked:true;
      li.classList.toggle('is-off',!on);
      let price=+(li.dataset.price||0);
      const sel=li.querySelector('[data-variant]');
      if(sel){const o=sel.tagName==='SELECT'?sel.selectedOptions[0]:sel;price=+(o.dataset.price||0);const pr=li.querySelector('[data-pr]');if(pr)pr.textContent=money(price);}
      if(on){tot+=price;n++;}
    });
    const ok=n>1,now=ok?Math.round(tot*0.9):tot;
    w.querySelector('[data-was]').textContent=ok?money(tot):'';
    w.querySelector('[data-now]').textContent=money(now);
    w.querySelector('[data-save]').textContent=ok?'You save '+money(tot-now)+' with this bundle':'Tick at least one add-on to unlock 10% off';
    w.querySelector('[data-bdl-add]').disabled=!ok;
    w.dataset.ready='1';
  }
  document.addEventListener('change',e=>{const w=e.target.closest('[data-cx-bundle]');if(w)bdl(w);});
  document.addEventListener('click',e=>{
    const b=e.target.closest('[data-bdl-add]');if(!b)return;
    const w=b.closest('[data-cx-bundle]');const items=[];
    w.querySelectorAll('[data-item]').forEach(li=>{
      const cb=li.querySelector('input[data-on]');if(cb&&!cb.checked)return;
      const sel=li.querySelector('[data-variant]');
      items.push({id:+(sel?sel.value:li.dataset.id),quantity:1,properties:{_bundle:'Bundle & save 10%'}});
    });
    if(items.length>1)addItems(items,w.dataset.code||'BUNDLE10',b);
  });

  /* build your own bundle */
  const tierPct=n=>n>=4?20:n===3?15:n===2?10:0;
  function byobRender(root){
    const sel=root._sel||new Map();const list=root.querySelector('[data-byob-items]');
    let sub=0;const arr=[...sel.values()];
    if(!arr.length){list.innerHTML='<li class="cx-byob__empty">No items yet. Pick gear from any brand.</li>';}
    else{list.innerHTML=arr.map(it=>{
      const v=it.variants.find(x=>x.id==it.vid)||it.variants[0];sub+=v.price;
      const opts=it.variants.length>1?'<select data-bs-var="'+esc(it.handle)+'" aria-label="Option for '+esc(it.title)+'">'+it.variants.map(x=>'<option value="'+x.id+'"'+(x.id==it.vid?' selected':'')+(x.available?'':' disabled')+'>'+esc(x.title)+' - '+money(x.price)+'</option>').join('')+'</select>':'';
      return '<li class="cx-bs"><img src="'+esc(it.img)+'" alt="" width="48" height="48" loading="lazy"><div><b>'+esc(it.title)+'</b><em>'+money(v.price)+'</em>'+opts+'</div><button type="button" class="cx-bs__x" data-bs-x="'+esc(it.handle)+'" aria-label="Remove '+esc(it.title)+'">&times;</button></li>';
    }).join('');}
    const n=arr.length,pct=tierPct(n),tot=Math.round(sub*(100-pct)/100);
    root.querySelector('[data-byob-n]').textContent=n;
    root.querySelector('[data-byob-sub]').textContent=money(sub);
    root.querySelector('[data-byob-off]').textContent=pct?('-'+pct+'% ('+money(sub-tot)+')'):'0%';
    root.querySelector('[data-byob-tot]').textContent=money(tot);
    root.querySelector('[data-byob-msg]').textContent=n===0?'Add 2 items to unlock 10% off':n===1?'Add 1 more item to unlock 10% off':n===2?'10% unlocked! Add 1 more for 15% off':n===3?'15% unlocked! Add 1 more for 20% off':'Maximum 20% off unlocked!';
    root.querySelectorAll('[data-tier]').forEach(t=>{const k=+t.dataset.tier;t.classList.toggle('is-on',k===4?n>=4:n===k);});
    root.querySelector('[data-byob-add]').disabled=n<2;
    const bar=root.querySelector('[data-byob-bar]');if(bar)bar.classList.toggle('is-on',n>0);
    const bt=root.querySelector('[data-byob-bartxt]');if(bt)bt.textContent=n+' item'+(n===1?'':'s')+' · '+money(tot)+(pct?' ('+pct+'% off)':'');
    root.querySelectorAll('.cx-bi').forEach(c=>{const on=sel.has(c.dataset.handle);c.classList.toggle('is-sel',on);const b=c.querySelector('[data-bi-add]');b.textContent=on?'Added ✓':'Add to bundle';b.setAttribute('aria-pressed',on?'true':'false');});
  }
  function byobFilter(root){
    const brand=root._brand||'';
    root.querySelectorAll('[data-panel]').forEach(p=>{let vis=0;p.querySelectorAll('.cx-bi').forEach(c=>{const hide=!!brand&&c.dataset.vendor!==brand;c.hidden=hide;if(!hide)vis++;});const none=p.querySelector('.cx-byob__none');if(none)none.hidden=vis>0;});
  }
  document.addEventListener('click',async e=>{
    const root=e.target.closest('[data-byob]');if(!root)return;
    if(!root._sel)root._sel=new Map();
    const chip=e.target.closest('[data-brand]');
    if(chip){root.querySelectorAll('[data-brand]').forEach(c=>c.setAttribute('aria-pressed',c===chip?'true':'false'));root._brand=chip.dataset.brand;byobFilter(root);return;}
    const tab=e.target.closest('[data-cat]');
    if(tab){root.querySelectorAll('[data-cat]').forEach(t=>t.setAttribute('aria-selected',t===tab?'true':'false'));root.querySelectorAll('[data-panel]').forEach(p=>{p.hidden=p.dataset.panel!==tab.dataset.cat;});return;}
    const x=e.target.closest('[data-bs-x]');
    if(x){root._sel.delete(x.dataset.bsX);byobRender(root);return;}
    const add=e.target.closest('[data-bi-add]');
    if(add){
      const c=add.closest('.cx-bi');const h=c.dataset.handle;
      if(root._sel.has(h)){root._sel.delete(h);byobRender(root);return;}
      add.textContent='Adding...';
      try{
        const p=await fetch('/products/'+h+'.js').then(r=>r.json());
        const variants=p.variants.map(v=>({id:v.id,title:v.title==='Default Title'?'Standard':v.title,price:v.price,available:v.available}));
        const first=variants.find(v=>v.available)||variants[0];
        root._sel.set(h,{handle:h,title:p.title,img:c.dataset.img,variants,vid:first.id});
      }catch(err){}
      byobRender(root);return;
    }
    if(e.target.closest('[data-byob-jump]')){root.querySelector('[data-byob-sum]').scrollIntoView({behavior:'smooth',block:'start'});return;}
    const go=e.target.closest('[data-byob-add]');
    if(go){const arr=[...root._sel.values()];if(arr.length<2)return;addItems(arr.map(it=>({id:+it.vid,quantity:1,properties:{_bundle:'Build your own bundle'}})),'BUNDLE'+tierPct(arr.length),go);}
  });
  document.addEventListener('change',e=>{const s=e.target.closest('[data-bs-var]');if(!s)return;const root=s.closest('[data-byob]');const it=root&&root._sel&&root._sel.get(s.dataset.bsVar);if(it){it.vid=+s.value;byobRender(root);}});

  /* recently viewed */
  function rv(){
    let L=[];try{L=JSON.parse(localStorage.getItem('cxRv')||'[]');}catch(e){}
    let curH='';const cur=document.querySelector('script[data-cx-rv]');
    if(cur){try{const d=JSON.parse(cur.textContent);curH=d.h;L=[d].concat(L.filter(x=>x.h!==d.h)).slice(0,12);localStorage.setItem('cxRv',JSON.stringify(L));}catch(e){}}
    document.querySelectorAll('[data-cx-recent]').forEach(s=>{
      const items=L.filter(x=>x.h!==curH).slice(0,8);if(!items.length)return;
      s.querySelector('[data-cx-recent-row]').innerHTML=items.map(x=>'<a class="cx-rv" href="'+esc(x.u)+'"><img src="'+esc(x.i)+'" alt="" loading="lazy" width="300" height="300"><b>'+esc(x.t)+'</b><span>'+esc(x.p)+'</span></a>').join('');
      s.hidden=false;
    });
  }

  /* glove size finder */
  function sf(w){
    const wt=+w.querySelector('[data-sf-w]').value,u=w.querySelector('[data-sf-u]').value,b=w.querySelector('[data-sf-b]');
    const T={spar:['12-14 oz','14 oz','16 oz','16-18 oz','18 oz'],bag:['10 oz','12 oz','14 oz','14-16 oz','16 oz'],fit:['10 oz','12 oz','12 oz','14 oz','16 oz'],fight:['8 oz','8-10 oz','10 oz','10 oz','10 oz']};
    const W={spar:'More padding protects you and your sparring partner.',bag:'A firmer, lighter glove gives speed and feedback on bags and pads.',fit:'Light enough for fast combos, padded enough for class rounds.',fight:'Always check your event rules: most amateur bouts use 8 to 10 oz.'};
    w.querySelector('[data-sf-oz]').textContent=T[u][wt-1];
    w.querySelector('[data-sf-why]').textContent=W[u];
    const a=w.querySelector('[data-sf-link]');a.href='/collections/'+b.value;a.textContent='Shop '+b.selectedOptions[0].text+' gloves';
  }
  document.addEventListener('change',e=>{const w=e.target.closest('[data-cx-sf]');if(w)sf(w);});

  /* tabs */
  document.addEventListener('click',e=>{
    const t=e.target.closest('.cx-tab');if(!t)return;
    const wrap=t.closest('[data-cx-tabs]');if(!wrap)return;
    wrap.querySelectorAll('.cx-tab').forEach(b=>b.setAttribute('aria-selected',b===t?'true':'false'));
    wrap.querySelectorAll('.cx-panel').forEach(p=>{p.hidden=p.id!==t.getAttribute('aria-controls');});
  });

  /* init */
  const first=document.querySelector('[data-cx-countdown]');
  if(first&&Date.parse(first.dataset.cxCountdown)<=Date.now())document.documentElement.classList.add('cx-expired');
  function tick(){cd();eta();document.querySelectorAll('[data-cx-bundle]:not([data-ready])').forEach(bdl);}
  tick();setInterval(tick,1000);
  document.querySelectorAll('[data-cx-sf]').forEach(sf);
  rv();
  const top=document.createElement('button');top.type='button';top.className='cx-top';top.setAttribute('aria-label','Back to top');top.innerHTML='&#8593;';
  top.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));document.body.appendChild(top);
  window.addEventListener('scroll',()=>top.classList.toggle('is-on',window.scrollY>900),{passive:true});
})();
